module.exports = __webpack_public_path__ + "img/温州市教育技术中心.600d8e94.png";